/**
 * Rule types that start a workflow run from a daily scheduled check instead of a patient event
 * (EN-5197). They can only be the first step, have a single (True) output, and a workflow holds
 * at most one of them because it has exactly one first step.
 */
export const SCHEDULED_RULE_TYPES = ["Inactivity", "DateEvent"] as const;

export function isScheduledRuleType(ruleType?: string): boolean {
  return (
    ruleType !== undefined &&
    (SCHEDULED_RULE_TYPES as readonly string[]).includes(ruleType)
  );
}
